import { List as MuiList, type ListProps as MuiListProps } from '@mui/material';
import * as stylex from '@stylexjs/stylex';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';

export type ListProps = Pick<MuiListProps, 'children' | 'sx'>;

const styles = stylex.create({
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
});

export function List({ children, sx }: ListProps) {
  const isFplMigrationEnabled = useFplMigrationFlag();

  if (!isFplMigrationEnabled) {
    return <MuiList sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ...sx }}>{children}</MuiList>;
  }

  return <ul {...stylex.props(styles.root)}>{children}</ul>;
}
